export default () => {
    const residences = document.querySelectorAll('[data-residences-name]');

    residences.forEach(residence => {
        residence.addEventListener('click', e => {
            e.preventDefault();

            const residenceID = residence.dataset.residencesName;

            document.getElementById(residenceID).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    });
}